/* KIMUO — panier multi-toiles (page Shopify, hors iframe).
   L'expérience (iframe sandbox) envoie chaque création ; ce fichier parle à Shopify (Ajax Cart API),
   affiche le panier KIMUO et ne confirme jamais un ajout avant la réponse effective de Shopify. */
(function () {
  'use strict';
  if (window.KIMUO_CART) return;
  var cfgEl = document.getElementById('kimuo-cart-config');
  if (!cfgEl) return;
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = CFG.t || {};
  // Upgrade only legacy copy already saved in theme settings; leave custom merchant wording untouched.
  var legacyCopy = {
    emptyTitle: ['Votre panier attend sa première toile.', 'Votre panier attend son premier kit.'],
    empty: ['Importez une photo, choisissez votre format : on s’occupe du reste.', 'Choisissez votre photo et personnalisez votre kit de peinture par numéros.'],
    another: ['+ Créer une autre toile', '+ Créer un autre kit'],
    added: ['Votre toile est dans le panier.', 'Votre kit est dans le panier.'],
    editHint: ['Le cadrage de votre photo est conservé. Pour changer de photo ou d’orientation, créez une nouvelle toile.', 'Le cadrage de votre photo est conservé. Pour changer de photo ou d’orientation, créez un nouveau kit.']
  };
  Object.keys(legacyCopy).forEach(function (key) {
    if (T[key] === legacyCopy[key][0]) T[key] = legacyCopy[key][1];
  });
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ———————————————————— données ———————————————————— */
  var variants = [];
  // Inline catalog avoids theme-editor fetch decoration of a data: JSON URL.
  function readCatalog() {
    if (CFG.catalog && Array.isArray(CFG.catalog.variants) && CFG.catalog.variants.length) return Promise.resolve(CFG.catalog);
    // An already-open page may still have the previous data URL configuration.
    if (/^data:application\/json,/i.test(CFG.fallback || '')) {
      try { return Promise.resolve(JSON.parse(decodeURIComponent(CFG.fallback.slice(CFG.fallback.indexOf(',') + 1).replace(/\+/g, '%20')))); }
      catch (e) { return Promise.reject(new Error('Le catalogue de formats est illisible. Rechargez la page.')); }
    }
    return fetch(CFG.fallback, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('Formats indisponibles.'); return r.json(); });
  }
  var catalog = readCatalog().then(function (data) {
    // The variant catalog is already rendered by Shopify Liquid on this page.
    // Do not wait for (or download) the same product a second time.
    variants = data.variants;
    return { productId: data.productId, handle: data.handle, variants: variants, currency: CFG.currency };
  });
  var cart = null, busy = 0, addPending = false, completed = {};
  function money(cents) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (cart && cart.currency) || CFG.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function api(path, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(ROOT + path, opts).then(function (r) {
      return r.text().then(function (txt) {
        var j = null; try { j = txt ? JSON.parse(txt) : null; } catch (e) { throw new Error('Réponse Shopify illisible (HTTP ' + r.status + ').'); }
        if (!r.ok || (j && j.status && j.status >= 400)) throw new Error((j && (j.description || j.message)) || ('Erreur Shopify (HTTP ' + r.status + ').'));
        return j;
      });
    }, function (err) { console.error('[KIMUO cart] Échec réseau', { path: path, name: err && err.name, message: err && err.message, originalBytes: opts.body instanceof FormData && opts.body.get('properties[Photo originale]') && opts.body.get('properties[Photo originale]').size, framedBytes: opts.body instanceof FormData && opts.body.get('properties[Photo cadrée]') && opts.body.get('properties[Photo cadrée]').size }); throw new Error(T.network || 'Connexion impossible. Vérifiez votre réseau et réessayez.'); });
  }
  function getCart() { return api('cart.js', { cache: 'no-store' }).then(function (c) { cart = c; render(); return c; }); }
  function variantOf(id) { return variants.find(function (v) { return String(v.id) === String(id); }); }
  function skuParts(sku) { var m = /^KIMUO-(\d+)X(\d+)-(\d+)$/.exec(sku || ''); return m ? { w: +m[1], h: +m[2], c: +m[3] } : null; }
  function orient(w, h) { return w === h ? 'carre' : w < h ? 'portrait' : 'paysage'; }
  function isKimuo(item) { return item.properties && item.properties['_Creation KIMUO']; }
  function lookOf(item) { try { return JSON.parse(item.properties['_Style'] || '{}'); } catch (e) { return {}; } }
  function prop(item, k) { return item.properties && item.properties[k]; }

  /* ———————————————————— ajout depuis l'expérience ———————————————————— */
  function frame() { return document.querySelector('iframe[data-kimuo-app]'); }
  function send(m) { var f = frame(); if (f && f.contentWindow) f.contentWindow.postMessage(m, '*'); }
  function sendCatalog() { catalog.then(function (c) { send({ kimuo: 'catalog', catalog: c }); }, function () {}); }

  // Fresh memory-backed Blobs belong to the storefront's renderer, not the sandbox's file handle.
  async function photoBlob(photo) {
    if (photo && photo.bytes instanceof ArrayBuffer) {
      if (!photo.bytes.byteLength || Number(photo.size) !== photo.bytes.byteLength) throw new Error('Le transfert de la photo est incomplet. Réimportez votre photo.');
      return new Blob([photo.bytes], { type: photo.type || 'application/octet-stream' });
    }
    // Support an iframe already loaded before the transport update, without forwarding its File.
    if (photo instanceof Blob) return photo;
    throw new Error('Importez votre photo et validez son cadrage avant de commander.');
  }

  function add(data) {
    var startedAt = performance.now(), fileReadyAt = 0, uploadedAt = 0;
    var speedDiag = /[?&]kimuo_diag=1(?:&|$)/.test(location.search);
    var id = data.requestId;
    if (completed[id]) return Promise.resolve(completed[id]);
    if (addPending) return Promise.reject(new Error('Un kit est déjà en cours d’ajout.'));
    addPending = true;
    return catalog.then(async function () {
      var choice = data.choice || {}, size = choice.size || {}, color = choice.color || {}, fmt = choice.format || {};
      var w = Number(size.w || size.width), h = Number(size.h || size.height);
      var sku = 'KIMUO-' + w + 'X' + h + '-' + Number(color.count);
      var v = variants.find(function (x) { return x.sku === sku; });
      if (!v) throw new Error('Ce format et ce nombre de couleurs ne correspondent à aucun kit.');
      if (v.available === false) throw new Error('Ce kit est momentanément indisponible.');
      var original = await photoBlob(data.original);
      fileReadyAt = performance.now();
      var pz = data.personalization || {}, look = data.look || {};
      var fd = new FormData();
      fd.append('id', String(v.id));
      fd.append('quantity', '1');
      fd.append('properties[Format]', String(fmt.label || orient(w, h)));
      fd.append('properties[Taille]', String(size.label || (w + ' × ' + h + ' cm')));
      fd.append('properties[Couleurs]', String(color.count));
      fd.append('properties[Photo originale]', original, (data.original.name || 'photo-originale.jpg').replace(/[^\w.\-]+/g, '-'));
      fd.append('properties[Confirmation photo]', '✓ Votre photo a bien été enregistrée');
      fd.append('properties[_Creation KIMUO]', id);
      fd.append('properties[_Format]', String(fmt.id || ''));
      fd.append('properties[_Cadrage]', JSON.stringify(pz.crop || null));
      fd.append('properties[_Placement]', JSON.stringify(pz.placement || null));
      fd.append('properties[_Partage autorisé]', pz.consent && pz.consent.shareCreation ? 'oui' : 'non');
      fd.append('properties[_Style]', JSON.stringify({ bg: look.bg || '', ink: look.ink || '', pal: (look.pal || []).slice(0, 8) }));
      fd.append('properties[_Personnalisation]', JSON.stringify(pz));
      return api('cart/add.js', { method: 'POST', body: fd }).then(function (res) {
        if (String(res.variant_id || res.id) !== String(v.id)) throw new Error('Shopify ne confirme pas le kit choisi.');
        uploadedAt = performance.now();
        return getCart();
      }).then(function (c) {
        var line = c.items.find(function (it) { return prop(it, '_Creation KIMUO') === id; });
        if (!line || !prop(line, 'Photo originale')) throw new Error('Le kit n’a pas été confirmé par Shopify. Vérifiez votre panier.');
        try { if (look.bg) localStorage.setItem('kimuo.look', JSON.stringify(look)); } catch (e) {}
        var ok = { kimuo: 'cart-result', requestId: id, ok: true };
        completed[id] = ok;
        var message = T.added || 'Votre kit est dans le panier.';
        if (speedDiag) {
          var tDone = performance.now();
          message += ' · Diagnostic : fichier ' + (original.size / 1048576).toFixed(1) +
            ' Mo · préparation ' + ((fileReadyAt - startedAt) / 1000).toFixed(1) +
            ' s · envoi Shopify ' + ((uploadedAt - fileReadyAt) / 1000).toFixed(1) +
            ' s · vérification ' + ((tDone - uploadedAt) / 1000).toFixed(1) + ' s';
          window.KIMUO_CART_TIMING = { bytes: original.size, preparationMs: fileReadyAt - startedAt, uploadMs: uploadedAt - fileReadyAt, verificationMs: tDone - uploadedAt };
        }
        open({ highlight: line.key, toast: message });
        return ok;
      });
    }).finally(function () { addPending = false; pendingPreview = null; if (el.root) { el.root.classList.remove('is-busy'); render(); } });
  }

  window.addEventListener('message', function (ev) {
    var f = frame();
    if (!f || ev.source !== f.contentWindow) return;
    var d = ev.data;
    if (!d || typeof d !== 'object') return;
    if (d.kimuo === 'cart-ready') { sendCatalog(); return; }
    if (d.kimuo === 'cart-open') { open(); return; }
    if (d.kimuo !== 'cart-add') return;
    var choice = d.choice || {}, size = choice.size || {}, color = choice.color || {};
    var w = Number(size.w || size.width), h = Number(size.h || size.height);
    var chosenSku = 'KIMUO-' + w + 'X' + h + '-' + Number(color.count);
    var selected = variants.find(function (x) { return x.sku === chosenSku; });
    if (selected && !addPending) {
      pendingPreview = { __pending: true, quantity: 1, variant_title: w + ' × ' + h + ' cm · ' + color.count + ' couleurs', final_line_price: Number(selected.price || 0) };
      build(); render();
    }
    var pendingAdd = add(d);
    if (addPending && !completed[d.requestId]) {
      // Show the existing cart at once; never claim upload success early.
      open();
      el.root.classList.add('is-busy');
      el.live.textContent = 'Enregistrement sécurisé de votre photo en cours…';
      el.live.classList.remove('err');
      clearTimeout(toastT);
      payDisabled(true);
    }
    pendingAdd.then(function (ok) { pendingPreview = null; render(); send(ok); }, function (e) {
      pendingPreview = null; render();
      say((e && e.message) || 'Impossible d’ajouter le kit. Réessayez.', true);
      send({ kimuo: 'cart-result', requestId: d.requestId, ok: false, error: (e && e.message) || 'Impossible d’ajouter le kit. Réessayez.' });
    });
  });
  document.addEventListener('DOMContentLoaded', function () { var f = frame(); if (f) f.addEventListener('load', sendCatalog); });
  sendCatalog();

  /* ———————————————————— interface ———————————————————— */
  var el = {}, lastFocus = null, isOpen = false, editing = null, toastT = 0, pendingPreview = null;
  function h(tag, attrs, kids) {
    var n = tag === 'svg' ? document.createElementNS('http://www.w3.org/2000/svg', tag) : document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === 'text') n.textContent = attrs[k]; else if (k === 'html') n.innerHTML = attrs[k]; else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]); else if (attrs[k] != null) n.setAttribute(k, attrs[k]); }
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function build() {
    if (el.root) return;
    el.root = h('div', { class: 'kc', 'aria-hidden': 'true' });
    el.bd = h('div', { class: 'kc__bd', onclick: close });
    el.panel = h('section', { class: 'kc__p', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'kc-title', tabindex: '-1' });
    el.bg = h('div', { class: 'kc__bg', 'aria-hidden': 'true' }, [h('i'), h('i'), h('i'), h('b')]);
    el.count = h('span', { class: 'kc__n' });
    el.close = h('button', { class: 'kc__x', type: 'button', 'aria-label': T.close || 'Fermer le panier', onclick: close }, [h('span', { 'aria-hidden': 'true', text: '×' })]);
    var head = h('header', { class: 'kc__h' }, [h('div', null, [h('p', { class: 'kc__eb', text: T.eyebrow || 'KIMUO' }), h('h2', { id: 'kc-title', text: T.title || 'Votre panier' })]), el.count, el.close]);
    el.list = h('ol', { class: 'kc__l', 'aria-label': T.listLabel || 'Vos kits' });
    el.empty = h('div', { class: 'kc__e' }, [h('p', { class: 'kc__et', text: T.emptyTitle || 'Votre panier attend son premier kit.' }), h('p', { text: T.empty || 'Choisissez votre photo et personnalisez votre kit de peinture par numéros.' })]);
    el.sub = h('strong', { class: 'kc__st' });
    el.subL = h('span', { text: T.subtotal || 'Sous-total' });
    el.note = h('p', { class: 'kc__nt', text: (T.note || 'Livraison incluse · Paiement sécurisé').replace(/\s+Shopify\b/gi, '') });
    el.pay = h('a', { class: 'kc__cta kc__pay', href: ROOT + 'checkout', target: window.self !== window.top ? '_blank' : '_self', rel: 'noopener', style: 'text-decoration:none;box-sizing:border-box', onclick: checkout }, [h('span', { text: T.checkout || 'Passer au paiement' })]);
    el.more = h('button', { class: 'kc__cta kc__more', type: 'button', onclick: another }, [h('span', { text: T.another || '+ Créer un autre kit' })]);
    el.live = h('p', { class: 'kc__live', role: 'status', 'aria-live': 'polite' });
    var foot = h('footer', { class: 'kc__f' }, [h('div', { class: 'kc__tot' }, [el.subL, el.sub]), el.note, el.pay, el.more, el.live]);
    el.panel.appendChild(el.bg);
    el.panel.appendChild(head);
    el.panel.appendChild(h('div', { class: 'kc__sc' }, [el.empty, el.list]));
    el.panel.appendChild(foot);
    el.root.appendChild(el.bd); el.root.appendChild(el.panel);
    document.body.appendChild(el.root);
    el.fab = h('button', { class: 'kc-fab', type: 'button', 'aria-label': T.open || 'Ouvrir le panier', onclick: function () { open(); } }, [
      h('svg', { viewBox: '0 0 24 24', 'aria-hidden': 'true', html: '<path d="M5 8h14l-1.2 11.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8L5 8z" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8" fill="none" stroke="currentColor" stroke-width="1.6"/>' }),
      h('span', { class: 'kc-fab__n' })]);
    if (CFG.fab !== false) document.body.appendChild(el.fab);
    el.panel.addEventListener('keydown', trap);
    applyLook();
  }
  function applyLook() {
    var look = null;
    try { look = JSON.parse(localStorage.getItem('kimuo.look') || 'null'); } catch (e) {}
    if (cart && cart.items) { for (var i = 0; i < cart.items.length; i++) { var l = lookOf(cart.items[i]); if (l && l.bg) { look = l; break; } } }   // Shopify lists the newest line first
    var r = el.root; if (!r) return;
    if (look && look.bg && look.bg !== 'none') { r.style.setProperty('--kc-cta', look.bg); el.fab.style.setProperty('--kc-cta', look.bg); }
    if (look && look.ink) { r.style.setProperty('--kc-cta-ink', look.ink); el.fab.style.setProperty('--kc-cta-ink', look.ink); }
    var pal = (look && look.pal) || [];
    ['--kc-b1', '--kc-b2', '--kc-b3'].forEach(function (v, i) { if (pal[i]) r.style.setProperty(v, pal[i]); });
  }
  function render() {
    build();
    var items = ((cart && cart.items) || []).slice();
    if (pendingPreview) items.push(pendingPreview);
    var n = items.reduce(function (a, it) { return a + it.quantity; }, 0);
    el.count.textContent = n ? (n + ' ' + (n > 1 ? (T.canvases || 'kits') : (T.canvas || 'kit'))) : '';
    el.fab.querySelector('.kc-fab__n').textContent = n || '';
    el.fab.classList.toggle('on', n > 0);
    el.fab.setAttribute('aria-label', (T.open || 'Ouvrir le panier') + (n ? ' (' + n + ')' : ''));
    el.sub.textContent = money(((cart && cart.total_price) || 0) + (pendingPreview ? pendingPreview.final_line_price : 0));
    el.empty.hidden = !!items.length;
    el.root.classList.toggle('is-empty', !items.length);
    payDisabled(!items.length || busy > 0 || addPending);
    el.list.textContent = '';
    items.forEach(function (it, i) { el.list.appendChild(row(it, i)); });
    applyLook();
  }
  function row(it, i) {
    if (it.__pending) {
      var preview = h('li', { class: 'kc__i is-new', 'aria-label': 'Kit en cours d’enregistrement' }, [
        h('div', { class: 'kc__th' }),
        h('div', null, [h('p', { class: 'kc__t', text: 'Kit ' + it.variant_title }), h('p', { class: 'kc__m', text: 'Enregistrement de votre photo en cours…' }), h('p', { class: 'kc__pr' }, [h('strong', { text: money(it.final_line_price) })])])
      ]);
      return preview;
    }
    var p = skuParts(it.sku) || {}, look = lookOf(it), kim = isKimuo(it);
    var img = prop(it, 'Photo originale') || (it.image || '');
    var li = h('li', { class: 'kc__i', 'data-key': it.key, style: 'animation-delay:' + Math.min(i, 6) * 60 + 'ms' });
    if (look.bg) li.style.setProperty('--kc-line', look.bg);
    var th = h('div', { class: 'kc__th' }, [img ? h('img', { src: img, alt: (T.photoAlt || 'Votre photo pour le kit') + ' ' + (i + 1), loading: 'lazy', width: '96', height: '120' }) : null]);
    if (p.w) th.style.aspectRatio = p.w + ' / ' + p.h;
    var title = h('p', { class: 'kc__t', text: (T.canvasTitle || 'Kit') + ' ' + (prop(it, 'Taille') || (p.w ? p.w + ' × ' + p.h + ' cm' : it.variant_title || '')) });
    var meta = h('p', { class: 'kc__m', text: [prop(it, 'Format'), (p.c || prop(it, 'Couleurs')) ? (p.c || prop(it, 'Couleurs')) + ' ' + (T.colors || 'couleurs') : ''].filter(Boolean).join(' · ') });
    var price = h('p', { class: 'kc__pr' }, [h('strong', { text: money(it.final_line_price) }), it.quantity > 1 ? h('span', { text: ' · ' + money(it.final_price) + ' ' + (T.each || 'l’unité') }) : null]);
    var minus = h('button', { type: 'button', class: 'kc__q-b', 'aria-label': (T.less || 'Retirer un exemplaire'), onclick: function () { setQty(it, it.quantity - 1); } }, ['−']);
    var plus = h('button', { type: 'button', class: 'kc__q-b', 'aria-label': (T.more || 'Ajouter un exemplaire'), onclick: function () { setQty(it, it.quantity + 1); } }, ['+']);
    var qn = h('span', { class: 'kc__q-n', 'aria-live': 'polite', text: String(it.quantity) });
    var qty = h('div', { class: 'kc__q', role: 'group', 'aria-label': T.qty || 'Quantité' }, [minus, qn, plus]);
    var acts = h('div', { class: 'kc__a' }, [
      kim && p.w ? h('button', { type: 'button', class: 'kc__lnk', onclick: function () { toggleEdit(it); } }, [T.edit || 'Modifier']) : null,
      h('button', { type: 'button', class: 'kc__lnk', onclick: function () { setQty(it, 0); } }, [T.remove || 'Supprimer'])]);
    var body = h('div', { class: 'kc__b' }, [title, meta, price, h('div', { class: 'kc__r' }, [qty, acts])]);
    li.appendChild(th); li.appendChild(body);
    if (editing === it.key) li.appendChild(editor(it, p));
    return li;
  }
  function editor(it, p) {
    var o = orient(p.w, p.h);
    var sizes = [];
    variants.forEach(function (v) { var q = skuParts(v.sku); if (q && orient(q.w, q.h) === o && !sizes.some(function (s) { return s.w === q.w && s.h === q.h; })) sizes.push(q); });
    sizes.sort(function (a, b) { return a.w * a.h - b.w * b.h; });
    var sel = { w: p.w, h: p.h, c: p.c };
    var box = h('div', { class: 'kc__ed' });
    function seg(label, opts, cur, pick) {
      var g = h('div', { class: 'kc__seg', role: 'radiogroup', 'aria-label': label });
      opts.forEach(function (op) {
        var b = h('button', { type: 'button', role: 'radio', 'aria-checked': String(cur(op)), class: 'kc__opt', onclick: function () { pick(op); Array.prototype.forEach.call(g.children, function (x, i) { x.setAttribute('aria-checked', String(cur(opts[i]))); }); upd(); } }, [op.label]);
        g.appendChild(b);
      });
      return h('div', { class: 'kc__eg' }, [h('p', { class: 'kc__el', text: label }), g]);
    }
    var pr = h('p', { class: 'kc__ep' });
    function target() { return variants.find(function (v) { return v.sku === 'KIMUO-' + sel.w + 'X' + sel.h + '-' + sel.c; }); }
    function upd() { var v = target(); pr.textContent = v ? money(v.price) + ' ' + (T.each || 'l’unité') : (T.unavailable || 'Indisponible'); save.disabled = !v || v.available === false; }
    var save = h('button', { type: 'button', class: 'kc__cta kc__sv', onclick: function () { saveEdit(it, target()); } }, [h('span', { text: T.save || 'Enregistrer' })]);
    box.appendChild(seg(T.size || 'Taille', sizes.map(function (s) { return { w: s.w, h: s.h, label: s.w + ' × ' + s.h }; }), function (op) { return op.w === sel.w && op.h === sel.h; }, function (op) { sel.w = op.w; sel.h = op.h; }));
    box.appendChild(seg(T.colorsTitle || 'Couleurs', [{ c: 36, label: '36' }, { c: 48, label: '48' }], function (op) { return op.c === sel.c; }, function (op) { sel.c = op.c; }));
    box.appendChild(h('p', { class: 'kc__eh', text: T.editHint || 'Le cadrage de votre photo est conservé. Pour changer de photo ou d’orientation, créez un nouveau kit.' }));
    box.appendChild(h('div', { class: 'kc__er' }, [pr, h('button', { type: 'button', class: 'kc__lnk', onclick: function () { editing = null; render(); } }, [T.cancel || 'Annuler']), save]));
    upd();
    return box;
  }
  function toggleEdit(it) { editing = editing === it.key ? null : it.key; render(); var li = el.list.querySelector('[data-key="' + cssEsc(it.key) + '"] .kc__opt'); if (li) li.focus(); }
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }

  /* ———————————————————— actions panier ———————————————————— */
  function lock(on) { busy += on ? 1 : -1; el.root && el.root.classList.toggle('is-busy', busy > 0); if (el.pay) payDisabled(busy > 0 || !(cart && cart.items.length)); }
  function say(msg, err) { build(); el.live.textContent = msg || ''; el.live.classList.toggle('err', !!err); clearTimeout(toastT); if (msg) toastT = setTimeout(function () { el.live.textContent = ''; }, err ? 9000 : 4200); }
  function setQty(it, q) {
    if (busy) return;
    lock(true);
    var li = el.list.querySelector('[data-key="' + cssEsc(it.key) + '"]');
    if (li && q === 0) li.classList.add('out');
    api('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: Math.max(0, q) }) })
      .then(function (c) { cart = c; if (editing === it.key && q === 0) editing = null; render(); say(q === 0 ? (T.removed || 'Kit retiré du panier.') : (T.updated || 'Quantité mise à jour.')); if (q === 0) focusAfterRemove(); })
      .catch(function (e) { if (li) li.classList.remove('out'); say(e.message, true); getCart().catch(function () {}); })
      .finally(function () { lock(false); });
  }
  function focusAfterRemove() { var b = el.list.querySelector('.kc__q-b') || el.more; if (b) b.focus(); }
  function saveEdit(it, v) {
    if (!v || busy) return;
    if (String(v.id) === String(it.variant_id)) { editing = null; render(); return; }
    lock(true);
    var props = Object.assign({}, it.properties);
    var q = skuParts(v.sku);
    props['Taille'] = q.w + ' × ' + q.h + ' cm';
    props['Couleurs'] = String(q.c);
    // une seule ligne par création : on ajoute la version modifiée, puis on retire l'ancienne (jamais l'inverse)
    api('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: it.quantity, properties: props }] }) })
      .then(function () { return api('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) }); })
      .then(function (c) { cart = c; editing = null; render(); say(T.saved || 'Kit modifié.'); })
      .catch(function (e) { say(e.message, true); return getCart(); })
      .finally(function () { lock(false); });
  }
  function payDisabled(off) {
    el.pay.toggleAttribute('disabled', off);
    el.pay.setAttribute('aria-disabled', off ? 'true' : 'false');
    el.pay.tabIndex = off ? -1 : 0;
  }
  function checkout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || addPending || !(cart && cart.items.length)) return;
    el.pay.classList.remove('is-go');
    var url = el.pay.href;
    try {
      if (window.self !== window.top) {
        var next = window.open(url, '_blank');
        if (!next) { say('Autorisez l’ouverture du nouvel onglet pour accéder au paiement.', true); return; }
        try { next.opener = null; } catch (ignore) {}
      } else {
        window.location.assign(url);
      }
    } catch (error) {
      say('Le navigateur a bloqué l’ouverture du paiement. Ouvrez l’aperçu dans un nouvel onglet puis réessayez.', true);
    }
  }
  function another() {
    close();
    var f = frame();
    if (f) {
      try { f.contentWindow.postMessage({ kimuo: 'goto', part: 'configurator' }, '*'); } catch (e) {}
      f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    } else location.href = ROOT;
  }

  /* ———————————————————— ouverture / fermeture ———————————————————— */
  function open(o) {
    o = o || {};
    build();
    if (!isOpen) { lastFocus = document.activeElement; isOpen = true; }
    el.root.setAttribute('aria-hidden', 'false');
    el.root.classList.add('is-open');
    document.documentElement.classList.add('kc-lock');
    var p = cart ? Promise.resolve(cart) : getCart();
    p.then(function () {
      if (o.highlight) { var li = el.list.querySelector('[data-key="' + cssEsc(o.highlight) + '"]'); if (li) { li.classList.add('is-new'); li.scrollIntoView({ block: 'nearest' }); } }
      if (o.toast) say(o.toast);
    }).catch(function (e) { say(e.message, true); });
    setTimeout(function () { (el.close).focus({ preventScroll: true }); }, reduce ? 0 : 60);
  }
  function close() {
    if (!el.root || !isOpen) return;
    isOpen = false; editing = null;
    el.root.classList.remove('is-open');
    el.root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kc-lock');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  function trap(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(el.panel.querySelectorAll('button,[href],input,select,[tabindex]:not([tabindex="-1"])'), function (x) { return !x.disabled && x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="/cart"],a[href="/cart"],[data-kimuo-cart-open]');
    if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); open(); }
  });
  window.KIMUO_CART = { open: open, close: close, refresh: getCart, add: add, get cart() { return cart; } };
  function boot() { build(); getCart().catch(function () { render(); }); if (/[?&]panier=1/.test(location.search)) open(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

